// Iter 129: rilevamento wrapper Android (WebView) — policy pagamenti Google Play: niente acquisti/link Stripe nell'app
export const isAndroidWebView = () => {
  const ua = navigator.userAgent || "";
  return /Android/i.test(ua) && (/; wv\)/.test(ua) || /Version\/\d+\.\d+.*Chrome\//.test(ua));
};

// Iter 147: spazio occupato dalla barra di navigazione Android (edge-to-edge, targetSdk 35+).
// Usa env(safe-area-inset-bottom) se la WebView lo espone, altrimenti 48px (barra a 3 tasti) solo nell'app Android.
export const androidBottomInsetPx = () => {
  if (!isAndroidWebView()) return 0;
  try {
    const el = document.createElement("div");
    el.style.cssText = "position:fixed;visibility:hidden;padding-bottom:env(safe-area-inset-bottom,0px)";
    document.body.appendChild(el);
    const v = parseFloat(getComputedStyle(el).paddingBottom) || 0;
    el.remove();
    return v > 0 ? Math.ceil(v) : 48;
  } catch {
    return 48;
  }
};
